import { ROUTES } from '../constants';
import streamApi from '../services/streamApi';
import { readStoredUser } from '../services/authApi';

const DIRECT_ADMIN_EMAILS = new Set(['admin@polarace.gg']);

function readStoredUserEmail() {
  const user = readStoredUser();
  return typeof user?.email === 'string' ? user.email.trim().toLowerCase() : '';
}

export async function resolvePostAuthRoute() {
  const email = readStoredUserEmail();
  if (DIRECT_ADMIN_EMAILS.has(email)) {
    return ROUTES.ADMIN;
  }

  try {
    const hasAdminAccess = await streamApi.canAccessAdmin();
    if (hasAdminAccess) {
      return ROUTES.ADMIN;
    }
  } catch {
    // Fall back to the default home route if admin detection is unavailable.
  }

  return ROUTES.HOME;
}
